export default "__VITE_ASSET__DcLqeqfu__"